import React, { lazy, useState } from 'react';
import { AGENTS_LIST } from '../../../../utils/constants/agents';
import LineChartDetails from './LineChartDetails';
import DateRangePicker from './DateRangePricker';
import PieChartDetails from './PieChartDetails';
import StatsBoxes from './StatsBoxes';
import CustomSelectCheckbox from '../../../../shared/select-checkbox/custom-selected-checkbox';

interface IInsights {
    dateRange?: any;
    selectedAgent?: any;
    isOpen: boolean;
    setIsOpen: any;
    allStats: any;
    totalSessions: any;
    onChange: (e: any, type?: string) => void;
    onRefreshData: () => void;
    onChangeSelectedAgent: (e: any, type?: any) => void;
}

const InsightsComponent = ({
    dateRange,
    selectedAgent,
    isOpen,
    setIsOpen,
    allStats,
    totalSessions,
    onChange,
    onRefreshData,
    onChangeSelectedAgent
}: IInsights) => {

    return (
        <div>
            <div className='flex flex-col md:flex-row md:justify-between md:items-center'>
                <div>
                    <CustomSelectCheckbox
                        name='Agent'
                        options={AGENTS_LIST}
                        placeholder='All Agents'
                        selectedOption={selectedAgent}
                        onChangeSelectedOption={onChangeSelectedAgent}
                    />
                </div>
                <div className='bg-[#F3F3F3] p-1 flex flex-row justify-between items-center'>
                    <DateRangePicker
                        dateRange={dateRange}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        onChange={onChange}
                    />
                    <p className='mx-5 text-primary-light text-sm  font-medium'>Showing {totalSessions || 0} Sessions</p>
                    <div onClick={onRefreshData} className='bg-white p-2 cursor-pointer hover:bg-gray-50 !rounded focus:bg-gray-100'>
                        <img src={'/assets/shared/refresh.svg'} className='object-contain w-[16px]' />
                    </div>
                </div>
            </div>
            <StatsBoxes
                sessions={allStats?.totalSessions}
                avgDuration={allStats?.avgSessionDuration}
                successSessions={allStats?.successSessions}
                failedSessions={allStats?.failedSessions}
            />
            <div className='grid grid-cols-1 md:grid-cols-8 gap-2 md:gap-4'>
                <div className='md:col-span-5'>
                    <LineChartDetails 
                    data={allStats?.sessionEndStatesGrouping}
                    />
                </div>
                <div className='md:col-span-3'>
                    <PieChartDetails
                        stats={allStats?.sessionEndStates}
                        totalSessions={totalSessions}
                    />
                </div>
            </div>
        </div>
    )
}
export default InsightsComponent;